// src/pages/Home.tsx
import Hero from "../components/home/Hero";
import Features from "../components/home/Features";
import AdvancedFeatures from "../components/home/AdvancedFeatures";
import Benefits from "../components/home/Benefits";
import Pricing from "../components/home/Pricing";
import Contact from "../components/home/Contact";

const Home = () => {
  return (
    <>
      <Hero />
      <Features />
      <AdvancedFeatures />
      <Benefits />
      
    </>
  );
};

export default Home;